import { Component, ParentProps } from "solid-js";
import cls from "./AuthLayout.module.scss";

export const AuthLayout: Component<ParentProps> = (props) => (
    <main class={cls.layout}>
        <div class={cls.layout__content}>
            {props.children}
        </div>
    </main>
)